import React from "react";
import { Tree, TreeNode } from "react-organizational-chart";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Dropdown, Card, Button } from '@themesberg/react-bootstrap';
import { faPlus, faUser, faCodeBranch, faTruckMonster } from "@fortawesome/free-solid-svg-icons";
import { getUserMembers } from "../../api/services/";
import { useState, useEffect } from "react";
import Preloader from "../../components/Preloader"; // Path to your code above
import TmsPopup from "../../../src/components/Popup"; // Path to your code above
import peopleIcon from "../../assets/img/team/people.svg";
import { Route, useHistory } from "react-router-dom";
import "./team.css";
import { Routes } from "../../routes";
import DriverAddFrom from "../../pages/forms/DriverAddForm"

function TeamPage() {
  const Node = ({ name, role, img }) => (
    <div className="node-card">
      <img src={img || peopleIcon} alt={name} className="node-img" />
      <div className="node-name">{name}</div>
      <div className="node-role">{role}</div>
    </div>
  );

  const [showLoader, setShowLoader] = useState(false); // Controls the loader
  const [orgData, setOrgData] = useState(null);
  const [showDriverAddWindow, setShowDriverAddWindow] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);
      try {
        const result = await getUserMembers();
        setOrgData(result);
        console.log("User Members:", result);
      } catch (error) {
        console.log("User Members fetch Error:", error.response?.data || error.message);
      }
      finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, []);

  const buildTreeFromTeam = (orgData) => {
    if (!orgData?.teams?.length) return null;

    const team = orgData.teams[0];

    // root = ADMIN
    const root = team.members.find(m => m.role === "ADMIN");

    if (!root) return null;

    return {
      name: root.fullName,
      role: root.role,
      children: team.members
        .filter(m => m.email !== root.email)
        .map(member => ({
          name: member.fullName,
          role: member.role,
          children: []
        }))
    };
  };

  const treeData = buildTreeFromTeam(orgData);

  const renderTree = (node) => {
    return (
      <TreeNode
        key={node.name}
        label={<Node name={node.name} role={node.role} />}
      >
        {node.children &&
          node.children.map((child) => renderTree(child))}
      </TreeNode>
    );
  };

  const history = useHistory();
  
  const handleEmployeeClick = async (e) => {
    setShowLoader(true);
    e.preventDefault();
    try {
      history.push(Routes.Team_Employee.path);
    }
    catch (error) {
      console.log("Team Employee Navigation Error:", error);
    } finally {
      setShowLoader(false);
    }
  };

  const handleDriverClick = async (e) => {
    // setShowLoader(true);
    e.preventDefault();
    setShowDriverAddWindow(true);
    // try {
    //   history.push(Routes.Team_Driver.path);

    // }
    // catch (error) {
    //   console.log("Team Driver Navigation Error:", error);
    // } finally {
    //   setShowLoader(false);
    // } 
  };

  const handlePartnerClick = async (e) => {
    setShowLoader(true);
    e.preventDefault();
    try {
      history
        .push(Routes.Team_Partner.path);
    }
    catch (error) {
      console.log("Team Partner Navigation Error:", error);
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <main>
      <Preloader show={showLoader} />
      <div>
        <Dropdown className="mt-4">
          <Dropdown.Toggle as={Button} variant="secondary" className="text-dark me-2">
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            <span>Invite New Member</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-2">
            <Dropdown.Item onClick={handleEmployeeClick}>
              <FontAwesomeIcon icon={faUser} className="text-info me-2" /> Employee
            </Dropdown.Item>
            <Dropdown.Item onClick={handlePartnerClick}>
              <FontAwesomeIcon icon={faCodeBranch} className="text-info me-2" /> Partner
            </Dropdown.Item>
            <Dropdown.Item onClick={handleDriverClick}>
              <FontAwesomeIcon icon={faTruckMonster} className="text-info me-2" /> Driver
            </Dropdown.Item>

            <Dropdown.Divider />

            {/* <Dropdown.Item>
            <FontAwesomeIcon icon={faRocket} className="text-danger me-2" /> Subscription Plan
          </Dropdown.Item> */}
          </Dropdown.Menu>
        </Dropdown>
        {/* <Card className="shadow-sm border-0 mt-4 p-4 vh-100 align-items-center">
        <h2 className="mb-4">Team Organization Chart</h2>

        <Tree
          lineWidth={"2px"}
          lineColor={"#ccc"}
          lineBorderRadius={"5px"}
          label={<Node name="Ankit Jaiswal" role="CEO" img="/images/ceo.jpg" />}>

          <TreeNode label={<Node name="Eric" role="CTO" img="/images/cto.jpg" />}>
            <TreeNode label={<Node name="Aman" role="Dev Manager" img="/images/manager.jpg" />}>
              <TreeNode label={<Node name="Dev 1" role="Developer" img="/images/dev1.jpg" />} />
              <TreeNode label={<Node name="Dev 2" role="Developer" img="/images/dev2.jpg" />} />
            </TreeNode>
          </TreeNode>

          <TreeNode label={<Node name="Neha Gupta" role="CFO" img="/images/cfo.jpg" />}>
            <TreeNode label={<Node name="nn" role="DE" img="/images/da.jpg" />} />
            <TreeNode label={<Node name="nn" role="DE" img="/images/da.jpg" />} />
          </TreeNode>

        </Tree>
      </Card> */}
        {/* <Card className="shadow-sm border-0 mt-4 p-4 vh-100 d-flex align-items-center">
        <h2 className="mb-4">Team Organization Chart</h2>

        {orgData && (
          <Tree
            lineWidth={"2px"}
            lineColor={"#ccc"}
            lineBorderRadius={"5px"}
            label={
              <Node
                name={orgData.fullName}
                role={orgData.role}
                img="/images/ceo.jpg"
              />
            }
          >
            {orgData.teams &&
              orgData.teams.map((team, index) => renderTree(team))}
          </Tree>
        )}
      </Card> */}
        <TmsPopup show={showDriverAddWindow}
        handleClose={() => setShowDriverAddWindow(false)}
        title="Add Driver"
        onSave={() => {
          console.log("Save clicked");
          setShowDriverAddWindow(false);
        }}>
          <DriverAddFrom />
        </TmsPopup>


        <Card className="shadow-sm border-0 mt-4 p-4 min-vh-100">
          <h2 className="mb-4">Team Organization Chart</h2>

          {treeData && (
            <Tree
              lineWidth={"2px"}
              lineColor={"#ccc"}
              lineBorderRadius={"5px"}
              label={
                <Node
                  name={treeData.name}
                  role={treeData.role}
                  img={peopleIcon}
                />
              }
            >
              {treeData.children.map((child) => renderTree(child))}
            </Tree>
          )}
        </Card>
      </div>
    </main>
  );
}

export default TeamPage;